import { render, staticRenderFns } from "./TestCreatingRoleSelection.vue?vue&type=template&id=5e187487&scoped=true&"
import script from "./TestCreatingRoleSelection.vue?vue&type=script&lang=js&"
export * from "./TestCreatingRoleSelection.vue?vue&type=script&lang=js&"
import style0 from "./TestCreatingRoleSelection.vue?vue&type=style&index=0&id=5e187487&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e187487",
  null
  
)

export default component.exports